import { render } from "./LayoutAccepter.vue?vue&type=template&id=ed26efce&scoped=true"
import script from "./LayoutAccepter.vue?vue&type=script&lang=js"
export * from "./LayoutAccepter.vue?vue&type=script&lang=js"

import "./LayoutAccepter.vue?vue&type=style&index=0&id=ed26efce&lang=less&scoped=true"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed26efce"]])

export default __exports__